module.exports = __webpack_public_path__ + "img/thumbnail-6.4cd15259.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-6.jpg
// module id = VF43
// module chunks = 1